import { blockUIConfig } from '@ajs/config/blockUI';
import { compileConfig } from '@ajs/config/compile';
import { httpConfig } from '@ajs/config/http';
import { routesConfig } from '@ajs/config/routes';
import { uiSelectConfig } from '@ajs/config/uiSelect';
import { eventsHandler } from '@ajs/run/events';
import { transitionsHandler } from '@ajs/run/transitions';
import * as angular from 'angular';
import { MODULE_NAME } from './config/constants';

// NPM AngularJS modules
import '@pioug/md-virtual-repeater';
import angularUIRouterModuleName from '@uirouter/angularjs';
import * as angularBlockUIModuleName from 'angular-block-ui';
import * as angularCookiesModuleName from 'angular-cookies';
import * as angularSanitizeUIModuleName from 'angular-sanitize';
import * as angularUIBootstrapModuleName from 'angular-ui-bootstrap';

// Fdx AngularJS Modules
import fdxModalModuleName from '../modules/modal';

// AngularJS Modules non-NPM
import './vendor/angular-file-upload.js';
import './vendor/angularUtils/pagination/dirPagination.js';
import './vendor/ngToast/ngToast.min.js';
import './vendor/ui-codemirror/ui-codemirror.js';
import './vendor/ui-select/select.min.js';
import './vendor/ui-sortable/sortable.js';

// Misc
import './vendor/feedonomics/utilities.js';

angular.module(MODULE_NAME,
    [
        angularSanitizeUIModuleName,
        angularUIBootstrapModuleName,
        angularUIRouterModuleName,
        angularCookiesModuleName,
        angularBlockUIModuleName,
        fdxModalModuleName,
        'ui.select',
        'angularFileUpload',
        'ui.codemirror',
        'angularUtils.directives.dirPagination',
        'ui.sortable',
        'ngToast',
        'virtualRepeat'
    ]
);
// Config blocks
angular.module(MODULE_NAME).config(compileConfig);
angular.module(MODULE_NAME).config(blockUIConfig);
angular.module(MODULE_NAME).config(httpConfig);
angular.module(MODULE_NAME).config(routesConfig);
angular.module(MODULE_NAME).config(uiSelectConfig);

// Run blocks
angular.module(MODULE_NAME).run(eventsHandler);
angular.module(MODULE_NAME).run(transitionsHandler);
